export type Review = {
  id: string;
  name: string;
  date: string;
  content: string;
  rating: number;
  avatar: string;
  url: string;
};

export const reviewsData: Review[] = [
  {
    id: "1",
    name: "Silvana Hernandez",
    date: "08/08/2023",
    content:
      "This place is very well organized and clean, the owners are also working there and make you feel like at home. Inside you can find the main services that are needed during a working day (like confortable desk and chair, air conditioner, break room, small kitchen, toilets, etc). In addition it is located in a strategic position: there are different options if you want to have luch outside, next to the city center, next to the beach if you want to take a break or go there after the end of business). I felt a very nice energy, so I super recommend it.",
    rating: 5,
    avatar: "/avatars/silvana.png",
    url: "https://maps.app.goo.gl/pr4N6nAfA9oS6zP96",
  },
  {
    id: "2",
    name: "Fabio D'Agostino",
    date: "28/07/2023",
    content:
      "Offerta top per giornate di lavoro in trasferta!! Personale cordiale e disponibile, tutti i servizi necessari per una giornata di lavoro : postazione con schermo grande, tastiera e mouse, Wi-Fi performante, caffè, tè e snack vari … tutto a due passi dal mare 🌊😊",
    rating: 5,
    avatar: "/avatars/fabio.png",
    url: "https://maps.app.goo.gl/MbYMUCKAhFyuX9yD7",
  },
  {
    id: "3",
    name: "Pasquale Marinelli",
    date: "05/07/2023",
    content:
      "Ho utilizzato il servizio per una giornata, avevo bisogno di una postazione momentanea per una call di lavoro. Uffici ordinati e puliti, scrivanie spaziose e Wi-Fi veloce. Consigliatissimo💯",
    rating: 5,
    avatar: "/avatars/pasquale.png",
    url: "https://maps.app.goo.gl/your-review-link-2",
  },
   {
    id: "4",
    name: "Eduan Botha",
    date: "17/07/2023",
    content:
      "It is a great space with friendly people at affordable prices. Spent the last 2 weeks working from here.",
    rating: 5,
    avatar: "/avatars/eduan.png",
    url: "https://maps.app.goo.gl/kCE74AWs2ak8HKdD8",
  },

     {
    id: "5",
    name: "Francesco Cipolla ",
    date: "07/04/2023",
    content:
      "Ottimo per chi, come me, lavora da remoto e cerca un luogo dove conoscere gente, condividere conoscenze oppure semplicemente stare in compagnia durante i break a lavoro.",
    rating: 5,
    avatar: "/avatars/francesco.png",
    url: "https://maps.app.goo.gl/rD4pkRiWaFzbiEXp8",
  },
       {
    id: "6",
    name: "Adrien Perazzi",
    date: "16/04/2023",
    content:
      "Good people, nice coffee, convenient place and cheap, the place to be in Trapani :)",
    rating: 5,
    avatar: "/avatars/adrien.png",
    url: "https://maps.app.goo.gl/pcPvvSFqGLtoxNuz5",
  },
];

export const overallRating = {
  average: 5.0,
  totalReviews: 26,
  googleProfileUrl: "https://maps.app.goo.gl/GhHfh3CqveVjEqcc9",
};